import { render } from "./PrintessModal.vue?vue&type=template&id=ccc1cbf6"
import script from "./PrintessModal.vue?vue&type=script&lang=js"
export * from "./PrintessModal.vue?vue&type=script&lang=js"

import "./PrintessModal.vue?vue&type=style&index=0&id=ccc1cbf6&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__